<div class="pharma-slider-filter">
  <div *ngIf="showLabel" class="label-section">
    <span>{{label}}</span>
    <!-- 
      output of below span
      ${{selectedMin}}M - ${{selectedMax}}M
      e.g. $200M - $600M
      -->
    <span class="value">
      <ng-container
        [ngTemplateOutlet]="showValue"
        [ngTemplateOutletContext]="{
          value: selectedMin,
          magnitude: magnitude,
          currency: currency
        }"
      >
      </ng-container> - <!-- Don't remove this hyphen -->
      
      <ng-container
        [ngTemplateOutlet]="showValue"
        [ngTemplateOutletContext]="{
          value: selectedMax,
          magnitude: magnitude,
          currency: currency
        }"
      >
      </ng-container>
    </span>
  </div>
  <div class="slider-section">
    <mat-slider [min]="min" [max]="max" [step]="step || 1">
      <input
        matSliderStartThumb
        [ngModel]="selectedMin"
        [disabled]="isDisabled"
        (ngModelChange)="onInstantMinChange($event)"
        (dragEnd)="onMinValueChange($event)"
      >
      <input
        matSliderEndThumb
        [ngModel]="selectedMax"
        [disabled]="isDisabled"
        (ngModelChange)="onInstantMaxChange($event)"
        (dragEnd)="onMaxValueChange($event)"
      >
    </mat-slider>
  </div>
  <div class="range-section">
    <div class="min-max-range">
      <span class="min-label">Minimum</span>
      <span>
        <span class="slider-value">
          <!-- 
            output of below code
            ${{min}}M 
            e.g. $200M 
          -->
          <ng-container
            [ngTemplateOutlet]="showValue"
            [ngTemplateOutletContext]="{
              value: min,
              magnitude: magnitude,
              currency: currency
            }"
          >
          </ng-container>
        </span>
      </span>
    </div>
    <div class="min-max-range">
      <span class="min-label">Maximum</span>
      <span>
        <span class="slider-value">
          <!-- 
            output of below code
            ${{min}}M 
            e.g. $200M 
          -->
          <ng-container
            [ngTemplateOutlet]="showValue"
            [ngTemplateOutletContext]="{
              value: max,
              magnitude: magnitude,
              currency: currency
            }"
          >
          </ng-container>
          <ng-template #showValue let-value="value" let-magnitude="magnitude" let-currency="currency">
            <ng-container *ngIf="valueFormatter">
              <ng-container
                [ngTemplateOutlet]="valueFormatter"
                [ngTemplateOutletContext]="{
                  amount: value,
                  magnitude: magnitude,
                  currency: currency
                }"
              >
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!valueFormatter">
              {{value}}
            </ng-container>
          </ng-template>
        </span>
      </span>
    </div>
  </div>
</div>